<template>
  <section class="sub_contents_wrap container">
    <div class="faq_list_wrap">
      <span v-for="(faq, index) in faqList" :key="index">
        <h3 class="acc_trigger" :id="faq.boardId">
          <a href="javascript:void(0)" @click="showFaq(faq.boardId)"
            ><span>Q</span>{{ faq.title }}</a
          >
        </h3>
        <div class="acc_container" style="display: none">
          <span>A</span>
          <div v-html="faq.content" class="fap_block"></div>
        </div>
      </span>
    </div>
  </section>
</template>
<script>
import $ from "jquery";
import { getFaqList } from "@/api/faq";
import router from '@/routes/index';

export default {
  data() {
    return {
      faqList: "",
      boardId: "",
    };
  },
  created() {
  if(this.$session.get('token') == null) {
      router.push('/login');
  } else {
    this.fetchData();
    $(".acc_container").hide();
  }  

  },
  methods: {
    async fetchData() {
      try {
        const response = await getFaqList();
        this.faqList = response.data.faqList;
      } catch (err) {
        console.log(err);
      }
    },
    showFaq(boardId) {
      if (
        $("#" + boardId)
          .next()
          .is(":hidden")
      ) {
        //If immediate next container is closed...
        $(".acc_trigger").removeClass("active").next().slideUp(); //Remove all .acc_trigger classes and slide up the immediate next container
        $("#" + boardId)
          .toggleClass("active")
          .next()
          .slideDown(); //Add .acc_trigger class to clicked trigger and slide down the immediate next container
        // open 된 faq 를 재클릭할 경우 닫힘
      } else if ($("#" + boardId).hasClass("active")) {
        $("#" + boardId)
          .removeClass("active")
          .next()
          .slideUp();
      }
      return false; //Prevent the browser jump to the link anchor
    },
  },
};
</script>

<style></style>
